import React from 'react'
import { CaretRight, CaretLeft } from 'phosphor-react'
import PaginationComponent from 'rc-pagination'
import PageFirst from 'assets/images/shell/icon-page-first.svg'
import PagePrev from 'assets/images/shell/icon-page-prev.svg'
import PageNext from 'assets/images/shell/icon-page-next.svg'
import PageLast from 'assets/images/shell/icon-page-last.svg'
/* eslint-disable */

function getPageItems(current, total) {
  if (total <= 7) {
    return Array.from({ length: total }, (_, index) => index + 1)
  }
  if (current <= 4) {
    return [1, 2, 3, 4, 5, 'ellipsis', total]
  }
  if (current >= total - 3) {
    return [1, 'ellipsis', total - 4, total - 3, total - 2, total - 1, total]
  }
  return [1, 'ellipsis', current - 1, current, current + 1, 'ellipsis', total]
}

function ListingPagination({ itemsCount, currentPage, onPageChange, pageSize }) {
  const totalPages = Math.max(1, Math.ceil((itemsCount || 0) / pageSize))
  const page = Math.min(Math.max(currentPage || 1, 1), totalPages)
  const goToPage = (nextPage) => {
    if (nextPage < 1 || nextPage > totalPages || nextPage === page) return
    onPageChange(nextPage)
  }

  return (
    <div className='listing-pager'>
      <button
        type='button'
        className='listing-pager__nav'
        aria-label='First page'
        disabled={page === 1}
        onClick={() => goToPage(1)}
      >
        <img src={PageFirst} width={20} height={20} alt='' />
      </button>
      <button
        type='button'
        className='listing-pager__nav'
        aria-label='Previous page'
        disabled={page === 1}
        onClick={() => goToPage(page - 1)}
      >
        <img src={PagePrev} width={20} height={20} alt='' />
      </button>
      <div className='listing-pager__pages'>
        {getPageItems(page, totalPages).map((item, index) =>
          item === 'ellipsis' ? (
            <span
              className='listing-pager__page listing-pager__page--ellipsis'
              key={`ellipsis-${index}`}
            >
              ...
            </span>
          ) : (
            <button
              key={item}
              type='button'
              className={`listing-pager__page${
                item === page ? ' listing-pager__page--active' : ''
              }`}
              aria-label={`Page ${item}`}
              aria-current={item === page ? 'page' : undefined}
              onClick={() => goToPage(item)}
            >
              <span>{item}</span>
            </button>
          )
        )}
      </div>
      <button
        type='button'
        className='listing-pager__nav'
        aria-label='Next page'
        disabled={page === totalPages}
        onClick={() => goToPage(page + 1)}
      >
        <img src={PageNext} width={20} height={20} alt='' />
      </button>
      <button
        type='button'
        className='listing-pager__nav'
        aria-label='Last page'
        disabled={page === totalPages}
        onClick={() => goToPage(totalPages)}
      >
        <img src={PageLast} width={20} height={20} alt='' />
      </button>
    </div>
  )
}

function Pagination({ itemsCount, currentPage, onPageChange, pageSize, variant }) {
  if (variant === 'listing') {
    return (
      <div className='pagination-main'>
        <ListingPagination
          itemsCount={itemsCount}
          currentPage={currentPage}
          onPageChange={onPageChange}
          pageSize={pageSize}
        />
      </div>
    )
  }

  return (
    <div className='pagination-main'>
      <nav aria-label='...'>
        <ul className='pagination'>
          <PaginationComponent
            className='pagination'
            onChange={onPageChange}
            current={currentPage}
            total={itemsCount}
            pageSize={pageSize}
            showTitle={false}
            hideOnSinglePage
            showLessItems
            showSizeChanger={false}
            // eslint-disable-next-line react/no-unstable-nested-components
            itemRender={(_current, _type, element) => (
              <p className='page-link page-linkk-otr'>
                <span className='page-linkk heading-xsb'>{element}</span>
              </p>
            )}
            prevIcon={
              <p className='page-link icon-otr'>
                <CaretLeft size={20} />
              </p>
            }
            nextIcon={
              <p className='page-link icon-otr'>
                <CaretRight size={20} />
              </p>
            }
          />
        </ul>
      </nav>
    </div>
  )
}

export default Pagination
